import React, { memo, useMemo, useState } from 'react'
import tw from 'twin.macro'
import { ContractorDetails } from 'src/interfaces/contractor'
import { ContractorGroupedStepItem } from './ContractorGroupedStepItem'
import {
  groupContractorSteps,
  getGroupedStepsWithDelayedInfo,
  sortCollectedDataSteps,
} from './contractorStepsUtils'
import { filterDeprecatedCollectedDataSteps } from 'src/utils/collectedData'

interface Props {
  contractorDetails: ContractorDetails
  isRequestApprove?: boolean
  onRefresh: () => void | Promise<void>
  isSubcontractor?: boolean
}

const ContractorStepsComponent = ({
  contractorDetails,
  isRequestApprove,
  onRefresh,
  isSubcontractor,
}: Props) => {
  const [openModalId, setOpenModalId] = useState<string | null>(null)

  const steps = useMemo(
    () =>
      sortCollectedDataSteps(filterDeprecatedCollectedDataSteps(contractorDetails.collectedData)),
    [contractorDetails.collectedData],
  )

  const groupedSteps = useMemo(() => groupContractorSteps(steps), [steps])

  const firstDelayedStepIndex = useMemo(
    () => steps.findIndex((item) => !!item.collectDataStepConfig?.delayed),
    [steps],
  )

  const groupedStepsWithDelayed = useMemo(
    () =>
      getGroupedStepsWithDelayedInfo(
        groupedSteps,
        contractorDetails?.collectedDataStatus,
        firstDelayedStepIndex,
      ),
    [groupedSteps, contractorDetails?.collectedDataStatus, firstDelayedStepIndex],
  )

  return (
    <div css={tw`flex flex-col gap-2`}>
      {groupedStepsWithDelayed.map(({ key, items, delayed }) => (
        <ContractorGroupedStepItem
          key={key}
          collectedDataItems={items}
          contractorDetails={contractorDetails}
          delayed={delayed}
          groupKey={key}
          openModalId={openModalId}
          isRequestApprove={isRequestApprove}
          onRefreshContractors={onRefresh}
          setOpenModalId={setOpenModalId}
          isSubcontractor={isSubcontractor}
        />
      ))}
    </div>
  )
}

export const ContractorSteps = memo(ContractorStepsComponent)
